
import { FileControlExtension, IFileControlExtensionContext } from "tessa/ui/files";
import { UIContext, showNotEmpty } from "tessa/ui";
import { ICardModel  } from "tessa/ui/cards";
import { CardRequest, CardService } from 'tessa/cards/service';
import { PkRequestTypes } from "src/pkScripts/Helpers/PkRequestTypes";
import { createTypedField, DotNetType, TypedField } from "tessa/platform";
import { PkCardTypes } from "src/pkScripts/Helpers/PkCardTypes";

export class ChAddContextMenuTemplates extends FileControlExtension {

    public async openingMenu(context: IFileControlExtensionContext) {
        const editor = UIContext.current.cardEditor;
        let model: ICardModel;

        if (editor == null || !(model = editor.cardModel!) || model.cardType.id !== PkCardTypes.PkOutgoingTypeID) {
            return;
        }
        
        var refDoc = null;
        var OutgoingRefDocs = model.card.sections.tryGet("OutgoingRefDocs");
        if (OutgoingRefDocs != null ) {
            if (OutgoingRefDocs.rows.length > 0 ) {
                refDoc = OutgoingRefDocs.rows[0].tryGet("DocID");
            }
        }

        let scanAction = context.actions.find(x => x.name === "AddFromTemplate"); 
        
        if (refDoc == null || scanAction == null)
        {
            return;
        }

        const request = new CardRequest();
        request.requestType = PkRequestTypes.ChGetThemeTemplateIncomming;
        request.info["cardID"] = createTypedField(refDoc, DotNetType.Guid);

        const response = await CardService.instance.request(request);
        await showNotEmpty(response.validationResult.build());
        if (response.validationResult.isSuccessful) {
            if ((response.info.incTemplates != null) ) {
                let incTemplates = response.info.incTemplates as Array<TypedField>;
                // Удаляет все action которые не родительские и не относятся к этим шаблонам
                if (scanAction != null) {
                    for(let index = (scanAction?.children.length -1); index >= 0; index--) {
                        let element = scanAction.children[index];
                        if ((element.children == null || element.children.length == 0)
                        && (!incTemplates.some(x => 
                            x.$value.toLowerCase() == element.name.toLowerCase())) )  {
                                scanAction?.children.splice(index, 1);
                            }
                        }
                    }
                    // scanAction.children.forEach(element => {
                    //     if ((element.children == null || element.children.length == 0)
                    //     && (!incTemplates.some(x => 
                    //         x.$value.toLowerCase() == element.name.toLowerCase())) )  {
                    //             scanAction?.children.splice(scanAction!.children.findIndex(x => x == element), 1);
                    //         }
                    //     });
                    // }
                }
        }
    }
}
